import { constants } from "../../../misc/helpers";
import MainTutorialScenario from "./MainTutorialScenario";

export default class MainTutorialScenarioSteps3And4 {
	constructor(private mainScenario: MainTutorialScenario, private onDone: () => void) {
	}

	public start() {
		this.step3RotateCameraWithByStander();
	}

	step3RotateCameraWithByStander() {
		var context = this;
		context.mainScenario.playSound('2', '4', () => {
		});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Locate the bystander and ask them to call 911'});
			this.mainScenario.playSequence('EnableBystander');
		context.mainScenario.rotateCameraNew(true, 0.20, 0.40, () => context.step4Call911(), () => context.step3OnRotateCameraWithBystanderIsNotSufficient());
	}

	step3OnRotateCameraWithBystanderIsNotSufficient() {
		this.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Call911);
	}

	step4Call911() {
		var context = this;
		context.mainScenario.playSound('2', '21', () => {
		});
		// context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
		// context.gameManager.UiManager.hideUi(constants.InGameUINames.RotateCamera);
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Call911, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onClick: (onResume: () => void) => {
				context.mainScenario.playSound('2', '8', () => {
					context.mainScenario.playSequence('BystanderPlayLips');
					context.mainScenario.playSound('2', '9', () => {
						context.mainScenario.playSequence('BystanderStopLips');
						context.mainScenario.gameManager.SoundManager.stopAllSounds();
					});
				});
				context.mainScenario.gameManager.UiManager.hideaAllUis();
				onResume();
			},
			onDone: () => {
				context.mainScenario.playSequence('EnableSecondCamera', null, () => {
					context.mainScenario.currentCamSliderValue = 50;
					setTimeout(() => {
						context.step3ARotateCameraWithByStander();
					}, 2000);
				});
			}
		});
	}

	step3ARotateCameraWithByStander() {
		var context = this;
		context.mainScenario.playSound('2', '5', () => {
		});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Locate the bystander and ask them to call 911'});
			this.mainScenario.playSequence('EnableBystander');
		this.mainScenario.rotateCameraNew(true, 0.20, 0.40, () => context.step4ACall911(), () => context.step3AOnRotateCameraWithBystanderIsNotSufficient());

	}

	step3AOnRotateCameraWithBystanderIsNotSufficient() {
		this.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Call911);
	}

	step4ACall911() {
		var context = this;
		context.mainScenario.playSound('2', '21', () => {
		});
		// context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
		// context.gameManager.UiManager.hideUi(constants.InGameUINames.RotateCamera);
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Call911, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onClick: (onResume: () => void) => {
				context.mainScenario.gameManager.UiManager.hideaAllUis();
				context.mainScenario.playSound('2', '8', () => {
					context.mainScenario.playSequence('BystanderPlayLips');
					context.mainScenario.playSound('2', '9', () => {
						context.mainScenario.playSequence('BystanderStopLips');
				context.mainScenario.gameManager.SoundManager.stopAllSounds();
			});
		});
				onResume();
			},
			onDone: () => {
				context.step2TryAgain();
			}
		});
	}

	private step2TryAgain() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to try again?',
			correctButton: {
				title: 'Try Again',
				greyedOut: true,
				onClick: () => { }
			},
			incorrectButton: {
				title: 'Next',
				greyedOut: true,
				onClick: () => { }
			}
		});
		context.mainScenario.playSound('2', '6', () => {
			context.mainScenario.playSound('2', '7', () => {
			});
		});
				context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Would you like to try again?',
					correctButton: {
						title: 'Try Again',
						onClick: () => context.Step2TryAgainConfirmed()
					},
					incorrectButton: {
						title: 'Next',
						onClick: () => context.step2TryAgainAfter()
					}

		});
	}

	private step2TryAgainAfter() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		context.onDone();
	}

	private Step2TryAgainConfirmed() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		context.mainScenario.playSequence('EnableFirstCamera', null, () => {
			context.mainScenario.currentCamSliderValue = 50;
		context.step3ARotateCameraWithByStander();
		});
	}

}